import React from 'react';
import { motion } from 'framer-motion';
import PillBadge from './PillBadge';
// import CLogoCollage from './CLogoCollage';


const CareerSection = () => {
  const careerItems = [
    {
      title: "XP&D (Experiential & Digital Platform)",
      location: "Gurugram (Haryana)",
      period: "from 2023",
      description: "Leading edit and motion design for experiential and digital projects; collaborating with creative, production and brand teams to deliver high-impact event and campaign content.",
      logo: "/xp_d_cover.jpg",
      logoStyle: "w-16 h-16 object-contain",
      duration: "1+ Year",
      type: "Current Role",
      highlights: ["Experiential Design", "Motion Graphics", "Brand Campaigns", "Digital Platforms"]
    },
    {
      title: "Zee Entertainment Enterprises Ltd. (Zee Live)",
      location: "Mumbai",
      period: "2020 – 2023",
      description: "Handled flagship live IPs and artist tours including ARTH – A Culture Fest, IAGT and Supermoon. Edited and produced assets for shows such as Supermoon B Praak, Supermoon Kalamkaar, YOHANI, Supermoon Magical Memories, Imran Khan India Tour, Arjun Kanungo Tour and Supermoon AP Dhillon India Tour.",
      logo: "/Zee_Live_logo.jpeg.jpg",
      logoStyle: "w-16 h-16 object-contain rounded-full",
      duration: "3 Years",
      type: "Senior Role",
      highlights: ["Live Events", "Artist Tours", "Cultural Festivals", "Broadcast Content"]
    },
    {
      title: "Scoop | Space Monkey Project",
      location: "Gurgaon",
      period: "2016 – 2020",
      description: "Edited 100+ corporate AVs, after films, government and internal projects for clients including Hero MotoCorp, Cheil India, Blenders Pride, WOW Awards, Indian Navy, Samsung and Luminous; contributed to large shows such as Bollywood Music Project, Arth – Culture Fest, Prateek Kuhad India Tour, Educare and Hero Annual Conferences.",
      logo: "/Scoop brand holding.jpg",
      logoStyle: "w-16 h-16 object-contain",
      duration: "3.5 Years",
      type: "Creative Lead",
      highlights: ["Corporate AVs", "Government Projects", "Music Events", "Brand Campaigns"]
    },
    {
      title: "QED Communications Pvt. Ltd.",
      location: "Gurgaon",
      period: "2012 – 2016",
      description: "Managed edit projects, shoots, media archives and coordination with the graphics team. Edited 100+ corporate AVs for Yamaha, PNB/MetLife, GE Capital, Taj Hotels, DTDC, Cadbury, Carlsberg India, Case Construction, DCM Shriram and Dettol; produced documentary films for Bahá'í Temple, UNICEF and the 'U & Me Against Dengue' campaign; delivered TVCs for Yamaha, Dettol, Indo‑Japan, Durex, Harpic and more.",
      logo: "/QED.png",
      logoStyle: "w-16 h-16 object-contain",
      duration: "4+ Years",
      type: "Junior to Mid",
      highlights: ["TV Commercials", "Documentary Films", "Corporate Content", "Brand Management"]
    }
  ];

  return (
    <section id="career" className="pb-20 pt-36 bg-black">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Header */}
         <motion.div
           initial={{ opacity: 0, y: 20 }}
           whileInView={{ opacity: 1, y: 0 }}
           transition={{ duration: 0.6 }}
           viewport={{ once: true }}
           className="mb-16"
         >
           <div className="flex flex-col items-start md:flex-row md:items-center gap-4 mb-8">
             <PillBadge text={"Career"} icon={''} />
             
             {/* Download Resume Button */}
             <motion.button
               initial={{ opacity: 0, y: 20 }}
               whileInView={{ opacity: 1, y: 0 }}
               transition={{ duration: 0.6, delay: 0.1 }}
               viewport={{ once: true }}
               whileHover={{ scale: 1.02, y: -1 }}
               whileTap={{ scale: 0.98 }}
               onClick={() => {
                 const resumeUrl = '/Prabhakar Pandey CV.pdf';
                 const link = document.createElement('a');
                 link.href = resumeUrl;
                 link.download = 'Prabhakar_Pandey_CV.pdf';
                 link.click();
               }}
               className="inline-flex items-center gap-2 bg-[#ffffff] border border-[#333333] text-black px-4 py-2 rounded-full text-sm font-medium hover:text-white hover:bg-[#1a1a1a] hover:border-[#444444] transition-all duration-300"
             >
               <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
               </svg>
               Download Resume
             </motion.button>
           </div>
           
           <motion.h2
             initial={{ opacity: 0, y: 20 }}
             whileInView={{ opacity: 1, y: 0 }}
             transition={{ duration: 0.6, delay: 0.2 }}
             viewport={{ once: true }}
             className="text-4xl md:text-5xl lg:text-6xl tracking-tight font-medium"
           >
             <span className="text-[#999999]">And This Is </span>
             <span className="text-white">My Career</span>
           </motion.h2>
         </motion.div>

        {/* Vertical list layout with separators, preserving logos */}
        <div className="divide-y divide-[#242424] border-t border-b border-[#242424]">
          {careerItems.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.05 }}
              viewport={{ once: true }}
              className="py-10"
            >
              <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-6">
                {/* Left: title, meta, logo */}
                <div className="flex items-start gap-4 min-w-0 md:w-1/3">
                  <div className="w-12 h-12 rounded-lg bg-white flex items-center justify-center p-1.5 flex-shrink-0">
                    <img src={item.logo} alt={`${item.title} logo`} className="w-9 h-9 object-contain" />
                  </div>
                  <div className="min-w-0">
                    <h3 className="text-white text-lg md:text-xl font-medium leading-tight break-words">
                      {item.title}
                    </h3>
                    <div className="mt-1 flex flex-wrap items-center gap-3 text-sm text-[#999999]">
                      <span className="inline-flex items-center gap-1">
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                        </svg>
                        {item.location}
                      </span>
                      <span className="inline-flex items-center gap-1">
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                        </svg>
                        {item.period}
                      </span>
                      {/* <span className="inline-flex items-center gap-2 text-white">
                        <span className="text-xs bg-[#333333] px-2 py-0.5 rounded-full">{item.duration}</span>
                        <span className="text-xs text-[#999999]">{item.type}</span>
                      </span> */}
                    </div>
                  </div>
                </div>

                {/* Right: description */}
                <p className="text-[#B3B3B3] md:w-2/3 leading-relaxed">
                  {item.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
      {/* <CLogoCollage /> */}
    </section>
  );
};

export default CareerSection;

